"use client"

import { fetchMyReports, fetchReports } from "@/services/publicationcenter"
import { ReportsItem, TabType } from "common/interface/interface"
import { ReportsParams } from "common/interface/params"
import { getTokenFromCookie } from "common/utils/cookie"
import { useLocale } from "next-intl"
import React, { useCallback, useEffect, useState } from "react"

import ReportPagination from "../Pagination"
import CardListItems from "./CardListItems"
import Style from "./index.module.scss"

async function getInitialReports(params: ReportsParams, is_own = false) {
	try {
		const data = is_own && params.auth_token ? await fetchMyReports(params) : await fetchReports(params)
		// console.log("[CardList] fetchReports success", data)
		return data || { list: [], info: { total: 0 } }
	} catch (err) {
		console.error("[CardList] fetchReports failed", err)
		return { list: [], info: { total: 0 } }
	}
}

type Props = {
	activeTab?: string
	itemId: number
	cycleId: number
	initialItems: ReportsItem[]
	total: number
	pageSize: number
}

const CardList: React.FC<Props> = ({ activeTab = TabType.REGULAR, itemId, cycleId, initialItems, total, pageSize }) => {
	const [items, setItems] = useState<ReportsItem[]>(initialItems)
	const [currentPage, setCurrentPage] = useState<number>(1)
	const [totalCount, setTotalCount] = useState<number>(total)
	const locale = useLocale()

	const queryCardList = useCallback(
		async (page: number = 1, size: number = pageSize) => {
			const data = await getInitialReports(
				{
					page,
					limit: size,
					item_id: itemId,
					cycle: cycleId,
					auth_token: getTokenFromCookie(),
				},
				activeTab === "my"
			)
			setItems(data.list || [])
			setTotalCount(data.info?.total || 0)
			setCurrentPage(page)
		},
		[itemId, cycleId, pageSize, activeTab]
	)

	useEffect(() => {
		setCurrentPage(1)
		setItems(initialItems)
	}, [initialItems])

	useEffect(() => {
		setTotalCount(total)
	}, [total])

	// 分页时调用，保持当前筛选条件
	const handleChange = async (page: number, size: number) => {
		await queryCardList(page, size)
		// DOM 更新后再滚动到 tab 位置
		requestAnimationFrame(() => {
			const anchorElement = document.getElementById("report-tab-anchor")
			if (anchorElement !== null) {
				const yOffset = -120 // 向上偏移 120px
				const y = anchorElement.getBoundingClientRect().top + window.pageYOffset + yOffset
				window.scrollTo({ top: y, behavior: "smooth" })
			}
		})
	}

	return (
		<>
			<section className={Style.cardlist}>
				<CardListItems items={items} locale={locale} />
			</section>
			<div className={Style.pagination}>
				<ReportPagination total={totalCount} currentPage={currentPage} pageSize={pageSize} onChange={handleChange} />
			</div>
		</>
	)
}

export default CardList
